import { InputNumber } from 'antd';
import { FC } from 'react';

import { formatNumber } from 'src/utils/common';

import styles from './IssueProductItem.module.scss';

export interface IssueProductItemProps {
  /** 상품명 */
  productName: string;
  /** 단가 */
  unitPrice: number;
  /** 수량 */
  quantity: number;
  /** 총 금액 */
  totalPrice: number;
  /** 계층 구조 표시 여부 */
  showHierarchy?: boolean;
  /** 수량 변경 기능 */
  editable?: {
    maxQuantity: number | undefined;
    /** 수량 변경 콜백 */
    onQuantityChange: (quantity: number) => Promise<void>;
  };
  /** 에러 상태 */
  hasError?: boolean;
  /** 에러 메시지 */
  errorMessage?: string;
  /** 마지막 요소 여부 */
  isLast?: boolean;
  /** 강조 표시 여부(이슈 등록된 상품) */
  isHighlight?: boolean;
}

export const IssueProductItem: FC<IssueProductItemProps> = ({
  productName,
  unitPrice,
  quantity,
  totalPrice,
  showHierarchy = false,
  editable,
  hasError = false,
  errorMessage,
  isLast = false,
  isHighlight = false,
}) => {
  const handleQuantityChange = async (value: number | null) => {
    if (editable?.onQuantityChange) {
      try {
        await editable.onQuantityChange(value || 0);
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div
      className={`${styles.container} ${showHierarchy ? styles.withHierarchy : ''} ${hasError ? styles.hasError : ''} ${
        isLast ? styles.isLast : ''
      }`}>
      {showHierarchy && <div className={styles.hierarchy}>{!isLast && <div className={styles.hierarchyBottom} />}</div>}
      <div className={styles.content}>
        <div className={styles.productName + (isHighlight ? ' ' + styles.highlight : '')}>{productName}</div>
        <div className={styles.priceRow}>
          {editable ? (
            <div className={styles.editableControls}>
              <InputNumber
                size='small'
                value={quantity}
                addonBefore={<span className={styles.unitPrice}>{formatNumber(unitPrice)}원</span>}
                max={editable.maxQuantity}
                onChange={handleQuantityChange}
                status={hasError ? 'error' : undefined}
                className={styles.quantityInput}
              />
              <div className={styles.totalPrice}>{formatNumber(totalPrice)}원</div>
            </div>
          ) : (
            <>
              <div className={styles.unitInfo}>
                {formatNumber(unitPrice)}원 x {formatNumber(quantity)}개
              </div>
              <div className={styles.totalPrice}>{formatNumber(totalPrice)}원</div>
            </>
          )}
        </div>
        {hasError && errorMessage && <div className={styles.errorMessage}>{errorMessage}</div>}
      </div>
    </div>
  );
};
